import * as React from 'react';
import { Textbox, ValidationProps } from 'ui';
import { CodetableFeature, CodetableMetadata } from '../../types-store';
import { CodetableTranslation } from '../../constants';
import { getValidationWithoutDuplicates } from 'app/area/codetable/item/code-pickers/helpers';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { ReadOnlyConfiguration, ReadOnlyType } from 'app/area/codetable/item/types';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { maxIconLength } from 'app/area/codetable/item/constants';

interface CodeIconProps {
  metadata: CodetableMetadata;
  codeItem: CodeItem;
  updateByKey: <T>(key: string, value: T) => void;
  resetValidation: (key: string) => void;
  translation: CodetableTranslation;
  validation?: { [key: string]: ValidationProps };
  readOnlyConfig?: ReadOnlyConfiguration;
}

export const CodeResidualIcon = ({ updateByKey, resetValidation, codeItem, translation, validation, readOnlyConfig }: CodeIconProps) => {

  const iconValidation = !!validation?.icon2 ? getValidationWithoutDuplicates(validation.icon2) : undefined;

  const onChange = (value: string) => {
    if (iconValidation) {
      resetValidation(CodetableFeature.icon2);
    }
    (!!codeItem?.residualIcon || !!value) && updateByKey(ScreenPicker.residualIcon, value.trim());
  };

  const readOnly = readOnlyConfig?.[ReadOnlyType.all];

  return <div className="col-lg-6 col-sm-12">
    <Textbox
      className={undefined}
      componentId="code-residual-icon"
      readOnly={readOnly}
      onChange={onChange}
      label={{ text: translation.residual_icon }}
      info={!readOnly && { text: translation.icon_description, visible: true }}
      validation={iconValidation}
      value={codeItem?.residualIcon}
      maxLength={maxIconLength}
    />
  </div>;
};
